import localization from 'reactor/localization';

localization.extend('ar', {
});